export const CONFIG = {
  "PROJECTNAME": "alsan",
  "COMPANYNAME": "Alsan",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10096005",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": false,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "rgba(217,39,42,255)",
    "primary100": "rgba(217,39,42,0.1)",
    "light": "rgba(217,39,42,255)",
    "secondary": "rgba(217,39,42,255)",
    "dark": "rgba(217,39,42,255)",
    "siteColor3": "#fff",
    "menuSecondary": "rgba(217,39,42,255)"
  }
};